import { render } from "./QuestionForm.vue?vue&type=template&id=0ef13bc2&scoped=true&ts=true"
import script from "./QuestionForm.vue?vue&type=script&lang=ts"
export * from "./QuestionForm.vue?vue&type=script&lang=ts"

import "./QuestionForm.vue?vue&type=style&index=0&id=0ef13bc2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ivan\\Desktop\\PROJECTS\\econom.landing-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef13bc2"]])

export default __exports__